/* eslint-disable */
import React, { useState, memo, useLayoutEffect, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { AppDispatch, RootState } from '../../store/store';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { openDialogSbp } from '../../store/reducers/openDialogSbpSlice';

const useStyles = makeStyles({
 dialog: {
  height: '100%',
 },

 dialogContainer: {
  '& .MuiDialog-container': {
   justifyContent: 'center',
   justifyItems: 'center',
   display: 'flex',
   width: '100%',
   backgroundColor: 'none',
   overflow: 'hidden',
   height: '1000px',
  },
  '& .MuiTypography-root': {
   display: 'flex',
   alignItems: 'center',
  },
  '& .MuiDialogContent-root': {
   overflow: 'hidden',
   padding: '0 !important',
   margin: '0 !important',
  },
  '& .MuiDialog-paper': {
   height: '735px',
  },
 },
 dialogTitle: {
  height: '20px',
  border: '1px solid #cacaca',
  color: 'black !important',
 },
 container: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  padding: 0,
  flexDirection: 'row',
 },
 headerTitle: {
  fontWeight: 'bold',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'calibri',
  padding: '5px 40px',
  borderRadius: '10px',
 },
 banner: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
 },
});

function PaperComponent(props: PaperProps) {
 return (
  <Draggable
   handle="#draggable-dialog-title"
   cancel={'[class*="MuiDialogContent-root"]'}
  >
   <Paper {...props} />
  </Draggable>
 );
}

/**
 * Окно банера.
 * @param props
 * @returns
 */
const DialogSbp = (props: any) => {
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();

 const openDialogSbpData = useSelector(
  (state: RootState) => state.openDialogSbp,
  shallowEqual,
 );

 //  useEffect(() => {
 //   setOpen(props.showSbpDialog);
 //  }, [props.timeStamp]);

 const closeDialogHandler = () => {
  dispatch(openDialogSbp(false));
  // setOpen(false);
 };

 return (
  <div>
   <Dialog
    className={classes.dialogContainer}
    open={openDialogSbpData}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
    PaperProps={{
     sx: {
      width: '700px',
      height: '750px',
      maxWidth: '700px',
      overflow: 'hidden',
      marginTop: '20px',
     },
    }}
   >
    <DialogTitle
     className={classes.dialogTitle}
     style={{
      cursor: 'move',
      backgroundColor: 'black',
      border: '1px black solid',
     }}
     id="draggable-dialog-title"
    >
     <div className={classes.container}>
      <div
       className={classes.headerTitle}
       style={{
        color: 'white',
        marginTop: '1px',
        marginLeft: '-40px',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
       }}
      >
       <div style={{ marginTop: '5px' }}>
        {sessionStorage.getItem('paymentType') === 'DR'
         ? 'Оплата цифровым рублём'
         : 'Оплата по СБП'}
       </div>
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         marginLeft: '30px',
         marginTop: '7px',
        }}
       ></div>
      </div>

      <div style={{ cursor: 'pointer', marginTop: '5px' }}>
       <CloseIcon
        style={{
         marginTop: '8px',
         marginRight: '-15px',
         fontWeight: 800,
         color: 'white',
        }}
        onClick={closeDialogHandler}
       />
      </div>
     </div>
    </DialogTitle>
    <DialogContent className={classes.dialog}>
     <div>
      <div style={{ fontSize: '24px', paddingLeft: '20px' }}>
       Итого к оплате:{' '}
       <b>{props.amountToPay ? `${props.amountToPay.toFixed(2)}₽` : `0₽`}</b>
      </div>

      <div style={{ height: '80vh', width: '100%', zIndex: 10000 }}>
       {/* Use an iframe to load the external URL content */}
       {props.dialogContent ? (
        <iframe
         src={props.dialogContent}
         title="external-content"
         width="100%"
         height="100%"
         frameBorder="0"
        />
       ) : (
        <p>Loading content...</p>
       )}
      </div>
     </div>
    </DialogContent>
   </Dialog>
  </div>
 );
};

export default memo(DialogSbp);
